import { render, staticRenderFns } from "./AddEditServiceArea.vue?vue&type=template&id=239fc0b2&scoped=true"
import script from "./AddEditServiceArea.vue?vue&type=script&lang=js"
export * from "./AddEditServiceArea.vue?vue&type=script&lang=js"
import style0 from "./AddEditServiceArea.vue?vue&type=style&index=0&id=239fc0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239fc0b2",
  null
  
)

export default component.exports